//draggableEvents.js
import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';

const DraggableEvents = ({ toggleModal }) => {
  return (
    <Card className="card-h-100">
      <CardBody>
        <Button
          color="primary"
          className="w-100 mb-3"
          onClick={toggleModal}
        >
          + Yeni Etkinlik Oluştur
        </Button>
        <p className="text-muted mb-3">Etkinliğinizi sürükleyip bırakın veya takvime tıklayın</p>
        <div id="external-events">
          <div className="external-event fc-event bg-info-subtle text-info"
            data-class="bg-info-subtle"
            data-event='{"title":"Rapor", "event_type":"Rapor"}'>
            <i className="mdi mdi-checkbox-blank-circle me-2"></i>Rapor
          </div>
          <div className="external-event fc-event bg-success-subtle text-success"
            data-class="bg-success-subtle"
            data-event='{"title":"Bakım", "event_type":"Bakım"}'>
            <i className="mdi mdi-checkbox-blank-circle me-2"></i>Bakım
          </div>
          <div className="external-event fc-event bg-warning-subtle text-warning"
            data-class="bg-warning-subtle"
            data-event='{"title":"Onarım", "event_type":"Onarım"}'>
            <i className="mdi mdi-checkbox-blank-circle me-2"></i>Onarım
          </div>
          <div className="external-event fc-event bg-primary-subtle text-primary"
            data-class="bg-primary-subtle"
            data-event='{"title":"Teklif", "event_type":"Teklif"}'>
            <i className="mdi mdi-checkbox-blank-circle me-2"></i>Teklif
          </div>
          <div className="external-event fc-event bg-secondary-subtle text-secondary"
            data-class="bg-secondary-subtle"
            data-event='{"title":"Hatırlatma", "event_type":"Hatırlatma"}'>
            <i className="mdi mdi-checkbox-blank-circle me-2"></i>Hatırlatma
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DraggableEvents;
